import { useContext } from 'react';

import { Navigate, Outlet, RouteProps, useLocation } from 'react-router';

import UserContext from './user-context';
import Auth from './views/Auth';
import MobilityCoach from './views/MobilityCoach';
import PaymentSuccessful from './views/PaymentSuccessful';
import Profile from './views/Profile';
import SignIn from './views/SignIn';
import SignUp from './views/SignUp';

type IRoute = RouteProps & {
  name: string;
  isProtected: boolean;
};

export const ROUTES_LIST: IRoute[] = [
  {
    path: '/',
    element: <Profile />,
    name: 'profile',
    isProtected: true,
  },
  {
    path: '/mobility-coach',
    element: <MobilityCoach />,
    name: 'profile',
    isProtected: true,
  },
  {
    path: '/auth',
    element: <Auth />,
    name: 'auth',
    isProtected: false,
  },
  {
    path: '/auth/signin',
    element: <SignIn />,
    name: 'signin',
    isProtected: false,
  },
  {
    path: '/auth/signup',
    element: <SignUp />,
    name: 'signup',
    isProtected: false,
  },
  {
    path: '/payment/successful',
    element: <PaymentSuccessful />,
    name: 'paymentSuccessful',
    isProtected: false,
  },
];

export function PrivateRoute() {
  const { user } = useContext(UserContext);

  return user ? <Outlet /> : <Navigate to="/auth" />;
}

export function AuthorizedRoute() {
  const { user } = useContext(UserContext);
  const location = useLocation();

  const payment = ROUTES_LIST.find(({ name }) => name === 'paymentSuccessful');

  if (payment && location?.pathname === payment.path) {
    return <Outlet />;
  }

  return user ? <Navigate to="/" /> : <Outlet />;
}
